const PROFILE_TECHNICIAN = 'technician'
const PROFILE_BUSINESS = 'business'

export default {
  PROFILE_TECHNICIAN: PROFILE_TECHNICIAN,
  PROFILE_BUSINESS: PROFILE_BUSINESS
}
